import { PropsWithChildren } from 'react'
import { Block } from 'ui-kit/blocks'
import classes from './SolutionSection.module.scss'

export const SolutionSection = ({ children }: PropsWithChildren) => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      {children}
    </Block>
  )
}
